import { render, staticRenderFns } from "./ShareToTeamForEditMain.vue?vue&type=template&id=b19325c8&scoped=true"
import script from "./ShareToTeamForEditMain.vue?vue&type=script&lang=js"
export * from "./ShareToTeamForEditMain.vue?vue&type=script&lang=js"
import style0 from "./ShareToTeamForEditMain.vue?vue&type=style&index=0&id=b19325c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19325c8",
  null
  
)

export default component.exports